/**
 * ランダム回答の帰無分布（人数別の偶然の水準）。
 *
 * 正典: apps/web/docs/新方針20260821/仕様_GB組織レポートの生成ロジック.html §04
 *
 * 【なぜ必要か】
 *  「分極率91%」が意味を持つのは、偶然ではそこまで行かないと言えるときだけ。
 *  偶然の水準は人数で変わる（少人数ほど偶然の偏りが出やすい）ので、固定閾値ではなく
 *  人数ごとの基準を持つ。
 *
 * 【作り方】
 *  ハーマン24問は6ペア×4問で、各問は2軸のどちらかに1点入る（合計は常に24）。
 *  各問を50%で無作為に答えた社員を n 人集め、分極率と最多タイプ占有率を計算する。
 *  これを n ごとに繰り返して分布を作り、中央値と95パーセンタイル点を取った。
 *  n<=100 は 20,000 回、それより上は 8,000 回。生成スクリプトは scripts/gen-org-null-table.mjs。
 *
 * 【検算】n=22 で 分極率 中央値64%・95%点77% ／ 最多タイプ占有率 中央値18%・95%点27%。
 *  仕様書§04が示す4つの値と一致する。
 *
 * このファイルは生成物。設問構成（ペアの軸組合せ・問数）が変わったら作り直すこと。
 */

/** [人数, 分極率95%点, 分極率中央値, 最多タイプ占有率95%点, 最多タイプ占有率中央値] */
export const ORG_NULL_TABLE: ReadonlyArray<readonly [number, number, number, number, number]> = [
  [  3, 0.667, 0.667, 0.667, 0.333],
  [  4, 1.000, 0.500, 0.500, 0.250],
  [  5, 0.800, 0.400, 0.600, 0.400],
  [  6, 0.667, 0.333, 0.500, 0.333],
  [  7, 0.857, 0.571, 0.429, 0.286],
  [  8, 0.750, 0.500, 0.375, 0.250],
  [  9, 0.667, 0.444, 0.444, 0.222],
  [ 10, 0.800, 0.400, 0.400, 0.200],
  [ 11, 0.727, 0.545, 0.364, 0.273],
  [ 12, 0.667, 0.500, 0.333, 0.250],
  [ 13, 0.769, 0.462, 0.385, 0.231],
  [ 14, 0.714, 0.571, 0.357, 0.214],
  [ 15, 0.667, 0.533, 0.333, 0.200],
  [ 16, 0.750, 0.500, 0.313, 0.188],
  [ 17, 0.706, 0.471, 0.294, 0.176],
  [ 18, 0.667, 0.556, 0.278, 0.222],
  [ 19, 0.737, 0.526, 0.316, 0.210],
  [ 20, 0.700, 0.500, 0.300, 0.200],
  [ 21, 0.667, 0.571, 0.286, 0.191],
  [ 22, 0.727, 0.545, 0.273, 0.182],
  [ 23, 0.696, 0.522, 0.261, 0.174],
  [ 24, 0.667, 0.500, 0.292, 0.208],
  [ 25, 0.720, 0.560, 0.280, 0.200],
  [ 26, 0.692, 0.538, 0.269, 0.192],
  [ 27, 0.667, 0.518, 0.259, 0.185],
  [ 28, 0.714, 0.500, 0.250, 0.179],
  [ 29, 0.690, 0.552, 0.276, 0.172],
  [ 30, 0.667, 0.533, 0.267, 0.167],
  [ 31, 0.710, 0.516, 0.258, 0.161],
  [ 32, 0.688, 0.563, 0.250, 0.188],
  [ 33, 0.667, 0.545, 0.242, 0.182],
  [ 34, 0.647, 0.529, 0.235, 0.176],
  [ 35, 0.686, 0.514, 0.257, 0.171],
  [ 36, 0.667, 0.556, 0.250, 0.167],
  [ 37, 0.649, 0.540, 0.243, 0.162],
  [ 38, 0.684, 0.526, 0.237, 0.158],
  [ 39, 0.667, 0.513, 0.231, 0.179],
  [ 40, 0.650, 0.550, 0.225, 0.175],
  [ 41, 0.683, 0.537, 0.244, 0.171],
  [ 42, 0.667, 0.524, 0.238, 0.167],
  [ 43, 0.651, 0.558, 0.233, 0.163],
  [ 44, 0.682, 0.545, 0.227, 0.159],
  [ 45, 0.667, 0.533, 0.222, 0.156],
  [ 46, 0.652, 0.522, 0.239, 0.174],
  [ 47, 0.638, 0.553, 0.234, 0.170],
  [ 48, 0.667, 0.542, 0.229, 0.167],
  [ 49, 0.653, 0.531, 0.225, 0.163],
  [ 50, 0.640, 0.560, 0.220, 0.160],
  [ 51, 0.667, 0.549, 0.216, 0.157],
  [ 52, 0.654, 0.538, 0.211, 0.154],
  [ 53, 0.641, 0.528, 0.226, 0.170],
  [ 54, 0.667, 0.556, 0.222, 0.167],
  [ 55, 0.654, 0.545, 0.218, 0.164],
  [ 56, 0.643, 0.536, 0.214, 0.161],
  [ 57, 0.667, 0.561, 0.210, 0.158],
  [ 58, 0.655, 0.552, 0.207, 0.155],
  [ 59, 0.644, 0.542, 0.220, 0.152],
  [ 60, 0.667, 0.533, 0.217, 0.150],
  [ 65, 0.646, 0.554, 0.215, 0.154],
  [ 70, 0.657, 0.543, 0.200, 0.157],
  [ 75, 0.640, 0.560, 0.200, 0.147],
  [ 80, 0.650, 0.550, 0.200, 0.150],
  [ 85, 0.635, 0.541, 0.200, 0.153],
  [ 90, 0.644, 0.556, 0.189, 0.144],
  [ 95, 0.632, 0.547, 0.190, 0.147],
  [100, 0.640, 0.560, 0.190, 0.150],
  [110, 0.636, 0.564, 0.182, 0.145],
  [120, 0.633, 0.550, 0.183, 0.142],
  [130, 0.631, 0.554, 0.177, 0.146],
  [140, 0.629, 0.557, 0.179, 0.143],
  [150, 0.627, 0.560, 0.173, 0.140],
  [160, 0.625, 0.563, 0.175, 0.138],
  [170, 0.624, 0.553, 0.171, 0.141],
  [180, 0.622, 0.556, 0.172, 0.139],
  [190, 0.621, 0.558, 0.168, 0.137],
  [200, 0.620, 0.560, 0.165, 0.135],
  [250, 0.616, 0.560, 0.160, 0.136],
  [300, 0.613, 0.560, 0.157, 0.133],
  [400, 0.605, 0.565, 0.150, 0.130],
  [500, 0.604, 0.564, 0.146, 0.128],
];

/** 帰無分布の1点（ある人数における偶然の水準）。 */
export interface OrgNullLevels {
  /** 分極率の95パーセンタイル点。これを超えたら偶然では説明しにくい */
  polar95: number;
  /** 分極率の中央値（偶然でもこのくらいは出る） */
  polarMedian: number;
  /** 最多タイプ占有率の95パーセンタイル点 */
  top95: number;
  /** 最多タイプ占有率の中央値 */
  topMedian: number;
}

/**
 * 人数から偶然の水準を引く。表に無い人数は前後の点を線形補間する。
 * 表の範囲外（3未満・500超）は端の値で頭打ちにする。
 */
export function getOrgNullLevels(n: number): OrgNullLevels {
  const t = ORG_NULL_TABLE;
  const pick = (row: (typeof t)[number]): OrgNullLevels => ({
    polar95: row[1],
    polarMedian: row[2],
    top95: row[3],
    topMedian: row[4],
  });
  if (n <= t[0][0]) return pick(t[0]);
  if (n >= t[t.length - 1][0]) return pick(t[t.length - 1]);
  for (let i = 1; i < t.length; i++) {
    if (n <= t[i][0]) {
      const lo = t[i - 1];
      const hi = t[i];
      const w = (n - lo[0]) / (hi[0] - lo[0]);
      const mix = (a: number, b: number) => a + (b - a) * w;
      return {
        polar95: mix(lo[1], hi[1]),
        polarMedian: mix(lo[2], hi[2]),
        top95: mix(lo[3], hi[3]),
        topMedian: mix(lo[4], hi[4]),
      };
    }
  }
  return pick(t[t.length - 1]);
}
